module.exports = __webpack_public_path__ + "4bd707b84be9d1972aeb91b1684560a8.pdf";